import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {useDocumentStore} from '@/components/document/store';
import {LocalizedString} from '@/model/types';
import {getLocalizedValue} from '@/utils/locale';

export const useDocumentLocale = () => {
  const locale = useDocumentStore(store => store.locale);

  const {t} = useTranslation(undefined, {lng: locale});

  const _t = useCallback((value?: string | LocalizedString) => getLocalizedValue(value, locale) ?? '', [locale]);

  return {t, _t, locale};
};
